import React, { useState, useEffect, useCallback } from "react";
import Modal from "react-modal";
import apiClient from '../../acciones/apiClient';
import { jwtDecode } from 'jwt-decode';
import "./imgNoti.css";

Modal.setAppElement('#root');

export const ImgNotifi = ({ img, titulo, descripcion, notifi_id }) => {
    const [comment, setComment] = useState("");
    const [comments, setComments] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const fetchComments = useCallback(async () => {
        try {
            const response = await apiClient.get(`/notificaciones/${notifi_id}/comentarios`);
            setComments(response.data);
        } catch (error) {
            console.error('Error al obtener comentarios:', error);
        }
    }, [notifi_id]);

    useEffect(() => {
        if (modalIsOpen) {
            fetchComments();
        }
    }, [modalIsOpen, fetchComments]);

    const handleCommentSubmit = async (e) => {
        e.preventDefault();
        console.log('handleCommentSubmit llamado'); // Confirmación de que se llama a la función
        const token = localStorage.getItem('token');
        console.log('Token desde localStorage:', token); // Imprime el token
    
        if (comment.trim() !== "") {
            try {
                if (!token) {
                    console.error('Token no encontrado en localStorage');
                    return;
                }
    
                const decodedToken = jwtDecode(token);
                console.log('Nombre de usuario:', decodedToken.nombre_usuario); // Ahora debería mostrar el nombre de usuario
    
                const response = await apiClient.post(
                    `/notificaciones/${notifi_id}/comentarios`,
                    { comentario: comment },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                console.log('Respuesta del servidor:', response.data);
    
                setComments((prevComments) => [
                    ...prevComments,
                    { usuario: decodedToken.nombre_usuario, comentario: comment }
                ]);
                setComment("");
            } catch (error) {
                console.error('Error al enviar comentario:', error.response ? error.response.data : error.message);
            }
        }
    };
    
    

    const toggleModal = () => {
        setModalIsOpen(!modalIsOpen);
    };

    return (
        <div className="notifiImg">
            <div className="fotonotifiImg">
                <h3>{titulo}</h3>
                <p>{descripcion}</p>
                {img ? (
                    <img src={img} alt="Notificación" />
                ) : (
                    <p>No hay imagen disponible</p>
                )}
                <button onClick={toggleModal} className="comment-buttonnotifiImg">Comentar</button>
            </div>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={toggleModal}
                contentLabel="Comments Modal"
                className="comments-modalnotifiImg"
                overlayClassName="comments-overlay"
            >
                <h2>Comentarios</h2>
                <form onSubmit={handleCommentSubmit} className="comment-formnotifiImg">
                    <input
                        type="text"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Añade un comentario..."
                    />
                    <button type="submit">Comentar</button>
                </form>
                <div className="commentsnotifiImg">
                    {comments.map((comment, index) => (
                        <div key={index} className="commentnotifiImg">
                            <strong>{comment.usuario}: </strong> {comment.comentario}
                        </div>
                    ))}
                </div>
                <button onClick={toggleModal} className="close-buttonnotifiImg">Cerrar</button>
            </Modal>
        </div>
    );
};
